import moment from "moment";

import {
  CsvFieldMapping,
  CsvImportField,
  mappedCsvValue,
} from "Components/Common/CsvImport/csvImportTypes";

export const PAYMENT_IMPORT_FIELDS: CsvImportField[] = [
  { key: "SomaliaRegion", label: "Somalia Region", required: true },
  { key: "MinistryDepartmentAgency", label: "Ministry / Department / Agency", required: true },
  { key: "ThematicArea", label: "Thematic Area" },
  { key: "Sector", label: "Sector" },
  { key: "FullName", label: "Full Name", required: true },
  { key: "StaffID", label: "Staff ID" },
  { key: "PassportOrIdNumber", label: "Passport or ID Number" },
  { key: "Gender", label: "Gender" },
  { key: "Email", label: "Email Address" },
  { key: "PositionTitle", label: "Position Title", required: true },
  { key: "PositionType", label: "Position Type", required: true },
  { key: "AdministratingAgency", label: "Administrating Agency", required: true },
  { key: "Project", label: "Project or Fund" },
  { key: "DonorOrFund", label: "Donor/Fund" },
  { key: "SupportAmountPerMonth", label: "Amount per Month" },
  { key: "AlignedWithHarmonizedSalary", label: "Aligned with Harmonized Salary" },
  { key: "PaymentCategory", label: "Payment Category", required: true },
  { key: "DurationStartDate", label: "Duration: Start Date", required: true },
  { key: "DurationEndDate", label: "Duration: End Date", required: true },
  { key: "DataProvidedBy", label: "Data Provided By", required: true },
  { key: "AdditionalComments", label: "Additional Comments" },
];

function normalizeDate(value: string | null): string | null {
  if (!value) return null;
  const date = moment(value, ["DD/MM/YYYY", "YYYY-MM-DD"], true);
  return date.isValid() ? date.format("YYYY-MM-DD") : value;
}

export function mapPaymentImportRow(
  row: Record<string, string>,
  mappings: CsvFieldMapping
) {
  const get = (key: string) => mappedCsvValue(row, mappings, key);
  return {
    region: get("SomaliaRegion"),
    mda: get("MinistryDepartmentAgency"),
    thematicArea: get("ThematicArea"),
    sector: get("Sector"),
    fullName: get("FullName"),
    staffId: get("StaffID"),
    passportOrIdNumber: get("PassportOrIdNumber"),
    gender: get("Gender"),
    emailAddress: get("Email"),
    positionTitle: get("PositionTitle"),
    positionType: get("PositionType"),
    agency: get("AdministratingAgency"),
    projectOrFund: get("Project"),
    donorOrFund: get("DonorOrFund"),
    amountPerMonth: get("SupportAmountPerMonth"),
    isSalaryAligned: get("AlignedWithHarmonizedSalary"),
    paymentCategory: get("PaymentCategory"),
    startDate: normalizeDate(get("DurationStartDate")),
    endDate: normalizeDate(get("DurationEndDate")),
    dataProvidedBy: get("DataProvidedBy"),
    additionalComments: get("AdditionalComments"),
  };
}
